
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { CalendarIcon, MapPinIcon } from "lucide-react";
import { format } from "date-fns";
import { Event } from "@/types";

interface EventSidebarProps {
  selectedDate: Date | undefined;
  eventsOnSelectedDate: Array<Event & { parsedStartDate: Date; parsedEndDate: Date }>;
  onEventClick: (event: Event) => void;
}

const EventSidebar = ({ 
  selectedDate, 
  eventsOnSelectedDate, 
  onEventClick 
}: EventSidebarProps) => {
  return (
    <Card className="h-full">
      <CardContent className="pt-6">
        <h3 className="text-lg font-medium mb-4">
          {selectedDate ? format(selectedDate, "MMMM d, yyyy") : "Select a date"}
        </h3>
        {eventsOnSelectedDate.length > 0 ? (
          <div className="space-y-3">
            {eventsOnSelectedDate.map(event => (
              <div 
                key={event.id} 
                className="p-3 border rounded-md cursor-pointer hover:bg-muted transition-colors"
                onClick={() => onEventClick(event)}
              >
                <h4 className="font-medium">{event.title}</h4>
                <div className="text-sm text-muted-foreground mt-1 flex items-center gap-1">
                  <CalendarIcon className="h-3 w-3" />
                  <span>
                    {format(event.parsedStartDate, "h:mm a")} - {format(event.parsedEndDate, "h:mm a")}
                  </span>
                </div>
                {event.location && (
                  <div className="text-sm text-muted-foreground mt-1 flex items-center gap-1">
                    <MapPinIcon className="h-3 w-3" />
                    <span>{event.location}</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="text-muted-foreground">No events on this date</p>
        )}
      </CardContent>
    </Card>
  );
};

export default EventSidebar;
